import React,{useState} from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, EffectCoverflow, Autoplay } from 'swiper/modules';
import 'swiper/css';
import { Link } from 'react-router-dom';

import 'swiper/css/effect-coverflow';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { EffectFade } from 'swiper/modules';
import VideoPlay from './VideoPlay';
const destinations = [
  {
    url: 'https://www.youtube.com/watch?v=iE4Wo6g0X54',
    thumbnail: 'https://img.youtube.com/vi/iE4Wo6g0X54/hqdefault.jpg',
  },
  {
    url: 'https://www.youtube.com/watch?v=Ku3uw2loFMg',
    thumbnail: 'https://img.youtube.com/vi/Ku3uw2loFMg/hqdefault.jpg',
  },
  {
    url: 'https://www.youtube.com/watch?v=1VK60Z0Lfxw',
    thumbnail: 'https://img.youtube.com/vi/1VK60Z0Lfxw/hqdefault.jpg',
  },
  {
    url: 'https://www.youtube.com/watch?v=vZgXZaHYm-U',
    thumbnail: 'https://img.youtube.com/vi/vZgXZaHYm-U/hqdefault.jpg',
  },
  {
    url: 'https://www.youtube.com/watch?v=1FO7vFawuLI',
    thumbnail: 'https://img.youtube.com/vi/1FO7vFawuLI/hqdefault.jpg',
  },
];

const MainLayout = () => {
     const [selectedVideo, setSelectedVideo] = useState(null);
  return (
    <div>
     

      <div className="th-hero-wrapper hero-1" id="hero">
       <Swiper
         effect="fade"
         loop={true}
         autoplay={{ delay: 5000 }}
         pagination={{ clickable: true }}
         navigation={true}
         modules={[EffectFade, Navigation, Pagination, Autoplay]}
         className="th-slider hero-slider-1"
      >
         {/* Image Slide 1 */}
         <SwiperSlide>
                       <img
             src="assets/img/hero/1.jpg"
             alt="Slide 1"
             className="w-full h-[100vh] object-cover"
           />
         </SwiperSlide>

         {/* Image Slide 2 */}
         <SwiperSlide>
           <img
             src="assets/img/hero/2.jpg"
             alt="Slide 2"
             className="w-full h-[100vh] object-cover"
           />
         </SwiperSlide>

         {/* YouTube Video Slide */}
         {/* <SwiperSlide>
           <div className="w-full h-[100vh] flex items-center justify-center bg-black">
           <iframe width="1920" height="627" src="https://www.youtube.com/embed/iE4Wo6g0X54?autoplay=1&mute=1&loop=1&playlist=iE4Wo6g0X54" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>

           </div>
         </SwiperSlide> */}
       </Swiper>
     </div>

          <section class="category-area bg-top-center" data-bg-src="assets/img/bg/category_bg_1.png">
         <div class="container th-container">
             <div class="title-area text-center">
                 <span class="sub-title">Upcoming Events</span>
                 <h2 class="sec-title">Drone Expo 2025</h2>

             </div>
             <div class="swiper th-slider has-shadow categorySlider" id="categorySlider1" data-bg-src="assets/img/bg/category_bg_1.png" data-slider-options='{"spaceBetween": "50","breakpoints":{"0":{"slidesPerView":1},"576":{"slidesPerView":"1"},"768":{"slidesPerView":"2"},"992":{"slidesPerView":"3"},"1200":{"slidesPerView":"3"},"1400":{"slidesPerView":"5"}}}'>
                 <div class="swiper-wrapper">
                    

                     <div class="swiper-slide">
                         <div class="category-card single">
                            <div class="box-img global-img">
                                <img src="assets/img/category/category_1_5.png" alt="Image"/>
                                 {/* <img src="assets/img/category/category_1_5.jpg" alt="Image"/> */}
                             </div>                             <h3 class="box-title"><a href="destination.html"> <i className="fa fa-calendar-alt mr-1"></i> April 24 - 26</a></h3>
                             <a class="line-btn" href="destination.html"><i className="fa fa-map-marker-alt mr-1"></i> HICC, Hyderabad, India</a>
                         </div>
                     </div>


                 </div>
                 <div class="slider-pagination"></div>
             </div>
        </div>
     </section>
     <div
  className="position-relative overflow-hidden"
  style={{ background: "rgba(243, 240, 216, 1)" }}
>
  <div className="container" style={{ marginTop: "2%" }}>
    <div className="title-area text-center">
      <span className="sub-title">Latest Videos</span>
    </div>

    <Swiper
      modules={[EffectCoverflow, Navigation, Pagination, Autoplay]}
      effect="coverflow"
      grabCursor={true}
      centeredSlides={true}
      slidesPerView={2}
      coverflowEffect={{
        rotate: 0,
        stretch: 95,
        depth: 212,
        modifier: 1,
        slideShadows: false,
      }}
      autoplay={{
        delay: 2500,
        disableOnInteraction: false,
      }}
      navigation
      pagination={{ clickable: true }}
      breakpoints={{
        576: { slidesPerView: 2 },
        992: { slidesPerView: 3 },
        1200: { slidesPerView: 3 },
      }}
      className="destination-slider"
    >
      {destinations.map((video, index) => (
        <SwiperSlide key={index}>
          <div className="destination-box gsap-cursor">
            <div className="destination-img" onClick={() => setSelectedVideo(video.url)}>
              <a href={video.url} target="_blank" rel="noopener noreferrer">
                <img src={video.thumbnail} alt={`video-${index}`} />
              </a>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  </div>
</div>

<section class="category-area bg-top-center" data-bg-src="assets/img/bg/category_bg_1.png">
         <div class="container th-container">
             <div class="title-area text-center">
                 <span class="sub-title">Latest News</span>
                 <h2 class="sec-title">Drone Expo 2025</h2>

             </div>
             <div class="swiper th-slider has-shadow categorySlider" id="categorySlider1" data-bg-src="assets/img/bg/category_bg_1.png" data-slider-options='{"spaceBetween": "50","breakpoints":{"0":{"slidesPerView":1},"576":{"slidesPerView":"1"},"768":{"slidesPerView":"2"},"992":{"slidesPerView":"3"},"1200":{"slidesPerView":"3"},"1400":{"slidesPerView":"5"}}}'>
                 <div >
                    

                     <div class="swiper-slide">
                         <div class="category-card single">
                            <div class="box-img global-img">
                                <img src="assets/img/category/category_1_5.png" alt="Image"/>
                                 {/* <img src="assets/img/category/category_1_5.jpg" alt="Image"/> */}
                             </div>                             <h3 class="box-title"><a href="destination.html"> <i className="fa fa-calendar-alt mr-1"></i> April 24 - 26</a></h3>
                             <a class="line-btn" href="destination.html"><i className="fa fa-map-marker-alt mr-1"></i> HICC, Hyderabad, India</a>
                         </div>
                     </div>


                 </div>
                 <div class="slider-pagination"></div>
             </div>
        </div>
     </section>

     <div
  className="position-relative overflow-hidden"
  style={{ background: "rgba(243, 240, 216, 1)" }}
>
  <div className="container" style={{ marginTop: "2%", marginBottom:"2%"}}>
    <div className="title-area text-center">
      <h2  class="sec-title">Join the Drone TV Community</h2 >
      <span className="sub-title">Join the Drone TV Community</span>
      <span class="sub-title">Connect with fellow drone enthusiasts, share 
        your experiences, and stay updated with the latest trends</span>
    </div>
     <div className="header-button" style={{justifyContent:"center"}}>
                       <Link to="/community" className="th-btn ">
                        Join Community
                       </Link>
                       <Link to="/community" className="th-btn">
                       Join WhatsApp Group
                       </Link>
                     </div>
  
  </div>
</div>

     <footer class="footer-wrapper footer-layout1">
        <div class="widget-area">
            <div class="container">
                <div class="newsletter-area">
                    <div class="newsletter-top">
                        <div class="row gy-4 align-items-center">
                            <div class="col-lg-5">
                                <h2 class="newsletter-title text-capitalize mb-0">Subscribe to Drone TV</h2>
                            </div>
                            <div class="col-lg-7">
                                <form class="newsletter-form">
                                    <input class="form-control " type="email" placeholder="Enter Email" required=""/>
                                    <button type="submit" class="th-btn style3">Subscribe Now <img src="assets/img/icon/plane.svg" style={{width:"50%", height:"50%"}} alt="/"/></button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-between">
                    <div class="col-md-6 col-xl-3">
                        <div class="widget footer-widget">
                            <div class="th-widget-about">
                                <div class="about-logo">
                                    <a href="home-travel.html"><img src="assets/img/hero/logo.jpg" alt="Tourm"/></a>
                                </div>
                              
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-auto">
                        <div class="widget widget_nav_menu footer-widget">
                            <h3 class="widget_title">Quick Links</h3>
                            <div class="menu-all-pages-container">
                                <ul class="menu">

                                <li>
                        <Link to="/" className="active">Home</Link>
                      </li>
                      <li>
                        <Link to="/video">Videos</Link>
                      </li>
                      <li>
                        <Link to="/event">Events</Link>
                      </li>
                      <li>
                        <Link to="/community">Community</Link>
                      </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-auto">
                        <div class="widget footer-widget">
                            <h3 class="widget_title">Address</h3>
                            <div class="th-widget-contact">
                                <div class="info-box_text">
                                    <div class="icon">
                                        <img src="assets/img/icon/phone.svg" alt="img"/>
                                    </div>
                                    <div class="details">
                                        <p style={{marginTop:"12px"}}><a href="tel:+917520123555" class="info-box_link">+91 7520123555</a></p>
                                    </div>
                                </div>
                                <div class="info-box_text">
                                    <div class="icon">
                                        <img src="assets/img/icon/envelope.svg" alt="img"/>
                                    </div>
                                    <div class="details">
                                        <p style={{marginTop:"12px"}}><a href="mailto:info@dronetv.in" class="info-box_link">info@dronetv.in</a></p>
                                    </div>
                                </div>
                                <div class="info-box_text">
                                    <div class="icon"><img src="assets/img/icon/location-dot.svg" alt="img"/></div>
                                    <div class="details">
                                        <p style={{marginTop:"12px"}}> HICC, Hyderabad, India</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-auto">
                        <div class="widget footer-widget">
                            <h3 class="widget_title">Social media</h3>
                            <div class="th-social">
                                    <a href="https://www.facebook.com/"><i class="fab fa-facebook-f"></i></a>
                                    <a href="https://www.twitter.com/"><i class="fab fa-twitter"></i></a>
                                    <a href="https://www.linkedin.com/"><i class="fab fa-linkedin-in"></i></a>
                                    <a href="https://www.whatsapp.com/"><i class="fab fa-whatsapp"></i></a>
                                    <a href="https://instagram.com/"><i class="fab fa-instagram"></i></a>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="copyright-wrap" data-bg-src="assets/img/bg/copyright_bg_1.jpg">
            <div class="container">
                <div class="row justify-content-between align-items-center" style={{textAlign:"center"}}>
                    <div class="col-md-6">
                        <p class="copyright-text">Copyright 2025 <a href="home-travel.html">AJS Innovations</a>. All Rights Reserved.</p>
                    </div>
                   
                </div>

            </div>
        </div>

    </footer>
    {selectedVideo && (
        <VideoPlay
          videoUrl={selectedVideo}
          onClose={() => setSelectedVideo(null)}
        />
      )}
    </div>
    
    
  );
};

export default MainLayout;
